import { BCMSRecord, useGlobalController ,useBCMSContext} from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import Classes from "model";
import { useEffect } from "react";
import DepositACheckPage, { getDefaultPageUI } from "components/pages/DepositACheckPage";

export default function CaptureMabiDepositsSelectAccount(props){
    const ui = getDefaultPageUI();
       const globalController = useGlobalController();
          BCMSRecord.globalControllerFor(Classes, globalController);
            const context = useBCMSContext();
             
              const { branding } = context.state;
              ui.accountDropdown.isOpen = true;

 useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });
    return <DepositACheckPage ui={ ui } />
}